// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6AXX8","controls":"styles_controls__3NMTG","charLimit":"styles_charLimit__HzP5P","input":"styles_input__1jOxI","send":"styles_send__Niv68"};